import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {KinderOrt} from '@dv/kitadmin/models';
import {DvLocalDateFormatPipe, DvMinutesFormatPipe, SpinnerComponent} from '@dv/shared/angular';
import {JaxWorkTimeViolation} from '@dv/shared/backend/model/jax-work-time-violation';
import {TranslocoDirective} from '@jsverse/transloco';

@Component({
    selector: 'dv-planung-violations',
    imports: [
        SpinnerComponent,
        TranslocoDirective,
        DvLocalDateFormatPipe,
        DvMinutesFormatPipe,
    ],
    templateUrl: './planung-violations.component.html',
    styles: `
    :host {
      display: block;
    }
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanungViolationsComponent {

    public violations = input.required<JaxWorkTimeViolation[]>();
    public kinderOrt = input.required<KinderOrt>();
    public range = input.required<string>();
    public isLoading = input<boolean>(false);

    public readonly closeDialog = output();
}
